<form [formGroup]="form">
  <ifc-base-filter-dialog [form]="form" (confirmed)="onConfirmed($event)">
    <mat-form-field appearance="outline" baseFilterItem>
      <mat-label>Name</mat-label>
      <input matInput formControlName="text" type="text" placeholder="Name" />
      <button
        type="button"
        *ngIf="form.get('text').value"
        matSuffix
        mat-icon-button
        aria-label="Clear"
        (click)="form.get('text').setValue('')"
      >
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>
    <mat-form-field appearance="outline" baseFilterItem>
      <mat-label>Type</mat-label>
      <mat-select matInput formControlName="category" placeholder="Type">
        <mat-option>All</mat-option>
        <mat-option *ngFor="let option of categoryOptions" [value]="option.value">{{ option.name }}</mat-option>
      </mat-select>
    </mat-form-field>

    <ifc-datepicker [fc]="form.get('fromDate')" baseFilterItem [label]="'Date from'"></ifc-datepicker>
    <ifc-datepicker [fc]="form.get('toDate')" baseFilterItem [label]="'Date to'"></ifc-datepicker>
  </ifc-base-filter-dialog>
</form>
